import { Source } from '../../queries/ats/titles/types/sources';
import { Title } from '../../queries/ats/titles/types/title';
import { TrackerEvent } from '../interfaces/tracker-event';

interface DetailPanelProperties {
  master_id: string;
  content_title: string;
  content_type: Title['type'];
  genres: string[];
  episode_number: number | undefined;
  season_number: number | undefined;
  series_id: string | undefined;
  provider_title_id: string;
  service_name: string;
  service_type: Source['type'];
  referral_id: string;
  page_slug: string | undefined;
  section_slug: string | undefined;
}

export class DetailsPanelOpenedEvent implements TrackerEvent<DetailPanelProperties> {
  public name = 'details_panel_opened';
  public properties: DetailPanelProperties;

  constructor(title: Title, source: Source, pageSlug?: string, sectionSlug?: string) {
    this.properties = {
      master_id: title.masterId,
      content_title: title.originalTitle,
      content_type: title.type,
      genres: title.genres,
      episode_number: title.type === 'episode' ? title.episode.sequenceNumber : undefined,
      season_number: title.type === 'episode' ? title.season.sequenceNumber : undefined,
      series_id: title.type === 'episode' ? title.series.masterId : undefined,
      provider_title_id: source.providerTitleId,
      service_name: source.name,
      service_type: source.type,
      referral_id: title.type === 'series' || title.type === 'episode' ? title.series.masterId : title.masterId,
      page_slug: pageSlug,
      section_slug: sectionSlug,
    };
  }
}
